import { Avatar, Clamp } from '@crehana/compass.ui';
import useProfileUITranslations from "../i18n/useProfileUITranslations";
import Subtitle from "./Subtitle";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Header = function Header(_ref) {
  var user = _ref.user,
    isSupplanting = _ref.isSupplanting,
    profileUrl = _ref.profileUrl;
  var _useProfileUITranslat = useProfileUITranslations(),
    t = _useProfileUITranslat.t;
  var thumbnailUrl = user.thumbnailUrl,
    fullName = user.fullName,
    email = user.email;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "tw-mb-1.6",
      children: [/*#__PURE__*/_jsx(Subtitle, {
        label: t('PROFILE_ACCOUNT')
      }), /*#__PURE__*/_jsxs("div", {
        className: "tw-flex tw-gap-1 tw-align-center tw-justify-start tw-min-w-0",
        children: [/*#__PURE__*/_jsx("a", {
          type: "button",
          href: profileUrl,
          target: "_blank",
          rel: "noreferrer",
          children: /*#__PURE__*/_jsx(Avatar, {
            src: thumbnailUrl,
            alt: fullName,
            size: isSupplanting ? 's' : 'm'
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "tw-flex tw-flex-col tw-items-start tw-justify-start tw-gap-0.4 tw-min-w-0",
          children: [/*#__PURE__*/_jsx("a", {
            type: "button",
            href: profileUrl,
            target: "_blank",
            rel: "noreferrer",
            className: "tw-truncate tw-w-full",
            children: /*#__PURE__*/_jsx(Clamp, {
              lines: 1,
              className: "tw-text-left tw-font-subtitle5 tw-w-full dark:tw-text-neutral-light-100",
              children: fullName
            })
          }), /*#__PURE__*/_jsx(Clamp, {
            lines: 1,
            className: "tw-text-left tw-font-body5 tw-text-neutral-light-700 dark:tw-text-neutral-dark-500 tw-w-full",
            children: email
          })]
        })]
      })]
    })
  });
};
export default Header;